import requests from '../../../../_00_elements/tools/requests-mixin';
import Logger from '../../../../_00_elements/tools/logger/logger';
import { URL_LOGIN } from '../../../../_00_elements/tools/routes/routes';
import Attach from '../../../../_00_elements/tools/attach';
import TwigFormValidator from '../../../../_00_elements/tools/twig-form/validator';
import { hideSubmitLoader, showSubmitLoader } from '../../../../_01_atoms/spinner';
import translation from '../../../../_00_elements/translation';
import Modal from '../../../../_01_atoms/components/Modal.vue';
import eventBus from '../../../../_00_elements/tools/event-bus';

/**
 * Login Modal Component
 * This component use the modal component as a child.
 * It displays the login popin which displays the form.
 */
export default {
  template: '#user-modal-component',
  components: {
    Modal,
  },
  props: [ 'isOpened', 'presetEmail', 'presetError', 'redirectUrl', 'presetSuccess' ],
  mixins: [ translation, requests ],
  delimiters: [ '${', '}' ],
  data() {
    return {
      htmlBody: '',
      rememberedUserName: this.presetEmail,
      modalTitle: '',
    };
  },
  methods: {
    switchTo(newModalName, args) {
      this.htmlBody = '';
      this.modalTitle = '';
      eventBus.dispatchEvent(
        new CustomEvent('switch-from-to-modal', {
          detail: { oldModalName: 'Login', newModalName, args },
        }),
      );
    },
    close() {
      this.htmlBody = '';
      this.modalTitle = '';
      this.$emit('close');
    },
    attachOnClickEventToOpenRegisterModal() {
      Attach.onClickEvent('switch-connection-button', () => {
        this.switchTo('RegisterChoice', [ this.redirectUrl ]);
      });
    },
    attachOnClickEventToOpenResettingPasswordModal() {
      Attach.onClickEvent('switch-resetting-password-button', () => {
        this.switchTo('ResettingPassword', [ this.redirectUrl, this.rememberedUserName ]);
      });
    },
    /**
     * when come from LoginPreSet
     * display login error if exist
     */
    setErrorIfAny() {
      if (this.presetError !== null && this.presetError !== undefined && this.presetError !== '') {
        this.$nextTick(() => {
          const userModalDiv = document.getElementById('login-modal');
          const formLogin = userModalDiv.querySelector('form');
          formLogin.insertAdjacentHTML('beforebegin', `<p class="error-message" >${this.presetError}</p>`);
          this.presetError = '';
        });
      }
    },
    /**
     * when come from LoginPreSet
     * display login success if exist
     */
    setSuccessIfAny() {
      if (this.presetSuccess !== null && this.presetSuccess !== undefined && this.presetSuccess !== '') {
        this.$nextTick(() => {
          const element = document.querySelector('#login-modal .buttons-list');
          element.insertAdjacentHTML('beforebegin', `<p class="success-message" >${this.presetSuccess}</p>`);
          this.presetSuccess = '';
        });
      }
    },
    processForm() {
      this.$nextTick(() => {
        eventBus.dispatchEvent(new Event('initialize-login-button'));
        this.attachOnClickEventToOpenRegisterModal();
        this.attachOnClickEventToOpenResettingPasswordModal();

        const formSelector = '#login-modal .form-login';
        const form = document.querySelector(formSelector);

        if (form.hasAttribute('has-submit-listener')) {
          return;
        }

        form.setAttribute('has-submit-listener', true);

        const validator = new TwigFormValidator({
          formSelector,
          rules: {
            _username: [ 'required', 'email' ],
            _password: 'required',
          },
          onSuccess: (event) => {
            event.preventDefault();
            const formData = new FormData(form);

            showSubmitLoader('.login-modal__submit');

            this.post(form.getAttribute('action'), formData, {
              headers: {
                'Cache-Control': 'no-cache',
                Pragma: 'no-cache', // Prevent caching AJAX calls on IE
              },
            })
              .then((result) => {
                try {
                  const jsonResponse = JSON.parse(result.data);
                  // Success
                  if (jsonResponse.reload) {
                    const targetPathElement = document.getElementById('_target_path');
                    if (targetPathElement) {
                      window.location.replace(targetPathElement.value);
                    } else if (this.redirectUrl) {
                      const url = this.redirectUrl.split('#')[0]; // remove #hash to prevent fail on window location
                      window.location.replace(url);
                    } else {
                      window.location.reload(true);
                    }
                  }
                } catch (exception) {
                  hideSubmitLoader('.login-modal__submit');
                  this.htmlBody = result.data;
                  this.processForm();
                }
              });
          },
        });
        validator.init();
      }).catch((error) => {
        Logger.debug(error);
      });
    },
  },
  watch: {
    isOpened(newVal) {
      if (!newVal) {
        return;
      }

      if (this.htmlBody !== '') {
        return;
      }

      this.modalTitle = this.trans('form.login.modal_title');

      const redirectUrlSlug = this.redirectUrl ? `?_redirectUrl=${encodeURIComponent(this.redirectUrl)}` : '';
      const FORMATTED_URL_LOGIN = URL_LOGIN + redirectUrlSlug;

      this.get(FORMATTED_URL_LOGIN).then((responseLogin) => {
        this.htmlBody = responseLogin.data;

        this.setErrorIfAny();
        this.setSuccessIfAny();

        this.processForm();
      });
    },
  },
};
